import React, { useState, useEffect } from "react";
import { Routes, Route, useNavigate, Navigate } from "react-router-dom";
import DashboardLayout from "../../layouts/DashboardLayout.tsx";
import AdminDashboard from "../admin/AdminLandingPage.tsx";
import LandingPage from "./LandingPage.tsx";
import UserList from "../admin/AllUsers.tsx";
import VerificationRequests from "../admin/VerificationRequests.tsx";
import VerificationRequestIn from "../admin/VerificationRequestIn.tsx";
import UploadDocuments from "../admin/DocumentsUpload.tsx";
import Brands from "../brand/BrandsManagement.tsx";
import Campaigns from "../brand/Campaigns.tsx";
import SingleCampaign from "../brand/SingleCampaign.tsx";
import AdminDocumentVerification from "../admin/AdminDocuments.tsx";
import AdminUserContacts from "../admin/UserContact.tsx";
import AdminCampaigns from "../admin/AdminCampaign.tsx";
import AdminBrands from "../admin/AdminBrandPage.tsx";
import { useRole } from "../../hooks/useUsers.ts";
import AdminOrganizations from "../admin/AdminOrg.tsx";
import ProfilePage from "./Profile.tsx";
import CampaignList from "../influencer/UserCampaigns.tsx";
import Orgprofile from "../brand/OrgProfile.tsx";
import ViewDocs from "../admin/ViewDocs.tsx";
import PostQuery from "../influencer/PostQuery.tsx";
import ViewQueries from "../admin/Adminquery.tsx";
import UserRequests from "../influencer/RequestPage.tsx";
import MyQueries from "../influencer/MyQueries.tsx";
import Loader from "../../components/Loader.tsx";
import Subscriptions from "../admin/Subscriptions.tsx";
import Payments from "../brand/Payments.tsx";
import Stats from "../brand/Stats.tsx";
import SubscriptionInfo from "../admin/SubscriptionInfo.tsx";
import AdminSubscription from "../admin/AdminSubscription.tsx";
import AdminInfluencerData from "../admin/AdminInfluencerData.tsx";
import { Notifications } from "./Notifications.tsx";
import InfluencerProfile from "../influencer/InfluencerProFile.tsx";
import Wallet from "../brand/Wallet.tsx";
import BankDetails from "../admin/BankDetails.tsx";
import AdminWallets from "../admin/AdminWallets.tsx";
import AdminPayments from "../admin/AdminPayments.tsx";
import WithdrawlRequest from "../admin/withdrawlRequest.tsx";
import ViewDocsIn from "../admin/ViewDocsIn.tsx";
import UserDashboard from "../influencer/UserDashboard.tsx";
import UserCampaignRequests from "../influencer/UserCampaignRequests.tsx";
import InfluencerSocialAccounts from "../influencer/influencer-SocialAccounts.tsx";
import InfluencerRequests from "../influencer/influencer-requests.tsx";
import InfluencerSubscriptions from "../influencer/Influencer-Subscriptions.tsx";
import ThemeSettings from "./ThemeSettings.tsx";
import UserProfile from "../influencer/UserProfile.tsx";
import AdminCoupons from "../admin/AdminCoupons.tsx";


const Dashboard = () => {
  const navigate = useNavigate();
  const [userType, setUserType] = useState<string | undefined>(undefined);
  const [loading, setLoading] = useState(true);

  const userString = localStorage.getItem('user');
  const user = userString ? JSON.parse(userString) : null;

  const { data: roleData, isLoading: isLoadingRole, error: roleError } = useRole(user?.user?.id);
  const fetchedRole = roleData?.user?.role;

  useEffect(() => {
    console.log('useEffect triggered for user role');
    console.log('Current user:', user);
    console.log('User role from localStorage:', user?.user?.role);
    console.log('User email:', user?.user?.email);

    /* Role fetching logic moved to useRole hook */

    // Fix the role detection logic
    if (user?.user?.role) {
      const role = user.user.role.toLowerCase();
      console.log('Role from user object:', role);

      if (role.includes('admin')) {
        setUserType('admin');
        setLoading(false);
      } else if (role.includes('organization')) {
        setUserType('organization');
        setLoading(false);
      } else if (role.includes('user')) {
        setUserType('user');
        setLoading(false);
      } else {
        console.log('Unknown role, defaulting to user');
        setUserType('user');
        setLoading(false);
      }
    } else {
      console.log('No role found, attempting to fetch role');
      if (user?.user?.id) {
        if (fetchedRole) {
          setUserType(fetchedRole.toLowerCase());
          console.log('User role fetched from hook:', fetchedRole);
          setLoading(false);
        } else if (roleError || (!isLoadingRole && !fetchedRole)) {
          // Fallback logic
          if (user?.user?.email?.includes('admin')) {
            console.log('Setting default admin role (fallback)');
            setUserType('admin');
          } else {
            console.log('Setting default user role (fallback)');
            setUserType('user');
          }
          setLoading(false);
        }
      } else {
        console.log('No user ID found, defaulting to user');
        setUserType('user');
        setLoading(false);
      }
    }
  }, [user]);

  if (loading) {
    return <Loader />
  }

  return (
    <DashboardLayout userType={userType || ""}>
      <Routes>
        <Route path="/profile" element={userType === 'user' ? <InfluencerProfile /> : userType === 'organization' ? <Orgprofile /> : <Navigate to={'/'} />} />
        <Route path="/campaings/requests/:id" element={userType === 'organization' ? <UserRequests /> : <Navigate to={'/'} />} />
        <Route path="/campaings/request" element={userType === 'user' ? <InfluencerRequests /> : <Navigate to={'/'} />} />
        <Route path="/subscriptions" element={userType === 'user' ? <InfluencerSubscriptions /> : userType === "organization" ? <Subscriptions /> : <AdminSubscription />} />
        <Route path="/payments" element={userType === 'organization' ? <Payments /> : <AdminPayments />} />
        <Route path="/stats" element={userType === 'organization' ? <Stats /> : <Navigate to={'/'} />} />
        <Route path="/notifications" element={<Notifications />} />
        {
          userType === 'organization' &&
          <Route path={`/user/profile/:id`} element={<UserProfile />} />
        }
        {
          userType === 'admin' &&
          <Route path={`/bankdetails`} element={userType === 'admin' ? <BankDetails /> : <Navigate to={'/'} />} />
        }
        {
          userType === 'admin' &&
          <Route path={`/withdrawl-request`} element={userType === 'admin' ? <WithdrawlRequest /> : <Navigate to={'/'} />} />
        }
        {
          userType === 'admin' &&
          <Route path={`/wallets/`} element={userType === 'admin' ? <AdminWallets /> : <Navigate to={'/'} />} />
        }
        {
          userType === 'organization' &&
          <Route path={`/user/wallet/:id`} element={<Wallet />} />
        }
        {
          userType === 'admin' &&
          <Route path="/viewdocs/:id" element={userType === 'admin' ? <ViewDocs /> : <Navigate to={'/'} />} />
        }
        {
          userType === 'admin' &&
          <Route path="/viewdocs/influencer/:influencerId" element={userType === 'admin' ? <ViewDocsIn /> : <Navigate to={'/'} />} />
        }
        {
          userType === 'admin' &&
          <Route path="/subscriptioninfo" element={userType === 'admin' ? <SubscriptionInfo /> : <Navigate to={'/'} />} />
        }
        {
          userType === 'admin' &&
          <Route path="/coupons" element={userType === 'admin' ? <AdminCoupons /> : <Navigate to={'/'} />} />
        }

        <Route path="/query" element={(userType === 'user' || userType === "organization") ? <PostQuery /> : <ViewQueries />} />
        <Route path="/myquery" element={(userType === 'user' || userType === "organization") ? <MyQueries /> : <PostQuery />} />
        <Route path="/" element={
          userType === "admin" ? <AdminDashboard /> :
            userType === "organization" ? <LandingPage /> :
              <UserDashboard />
        } />
        <Route path="/users/all" element={<UserList />} />
        <Route path="/users/influencers" element={<AdminInfluencerData />} />
        <Route path="/org/all" element={userType === "admin" ? <AdminOrganizations /> : <LandingPage />} />
        <Route path="/verification/requests" element={<VerificationRequests />} />
        <Route path="/influencer/requests" element={<VerificationRequestIn />} />
        <Route path="/contacts/users" element={<AdminUserContacts />} />
        <Route path="/documents" element={<UploadDocuments />} />
        <Route path="/documents/verify" element={<AdminDocumentVerification />} />
        <Route path="/brands" element={userType === "admin" ? <AdminBrands /> : <Brands />} />
        <Route path="/campaings" element={userType === 'admin' ? <AdminCampaigns /> : userType === "user" ? <CampaignList /> : <Campaigns />} />
        <Route path="/campaings/:id" element={<SingleCampaign />} />
        <Route path="/social/accounts" element={userType === 'user' ? <InfluencerSocialAccounts /> : <Navigate to={'/'} />} />
        <Route path="/settings/theme" element={<ThemeSettings />} />
      </Routes>
    </DashboardLayout>
  );
};

export default Dashboard;